<template lang="pug">
.color.data.left(:class="{'new-item': isNew}")
  .data-general-information(@click="expand = !expand")
    .item-list.color-bug
      .data-number-list(:class="{hidden: isNew}") {{ isNew ? 0 : index + 1 }}
      .color-preview(:style="data.hexadecimal && data.hexadecimal[0] !== '-' ? `border-color:#${data.hexadecimal}` : ''" :class="data.color")
      .data-information-list
        .data-title-list.capitalize {{ data.color }}
        .data-description-list.capitalize(v-if="!history") {{ data.spanish }}
        .data-description-list.capitalize(v-else :class="colorTransaction(data.transaction)") {{ data.transaction }}d
          span.lowercase  - {{ dateTime(data.createdAt) }}

  transition.user-details-information(name="slide-fade")
    shForm.list(v-if="expand && !history" :dataOriginal="data" :fillData="true")

  transition.user-details-information(name="slide-fade")
    shHistory(v-if="expand && history" :dataOriginal="data" :color="colorTransaction(data.transaction)")

  //.check-list(v-model="checked")
    .input-container-checkbox
      label.label-checkbox-list(:for="`Check${index}`")
        input.input-checkbox-list(:id="`Check${index}`" type="checkbox")
        .checkmark
</template>

<script>
import shForm from './Form'
import shHistory from './History'
import shExpandButton from '@/components/elements/ExpandButton'
import mFilters from '@/mixins/filters'
import mForm from '@/mixins/form'

export default {
  name: 'Color',

  mixins: [mFilters, mForm],

  components: { shForm, shExpandButton, shHistory },

  props: {
    data: Object,
    index: Number,
    isNew: Boolean,
    history: Boolean
  },

  data () {
    return {
      checked: false,
      expand: false
    }
  },

  beforeDestroy () {
    this.expand = false
  }
}
</script>

<style lang="stylus">
.item-list.color-bug
  transform scale(1)

.litmus, .gold, .silver
  border-color transparent
  background-clip padding-box !important
  position relative
  background var(--background-principal)

.litmus:after, .gold:after, .silver:after
  position absolute
  top -3px
  bottom -3px
  left -3px
  right -3px
  content ""
  z-index -1
  border-radius 50%

.litmus:after
  background linear-gradient(130deg,#868a47,#551e7c 18%,#003e88 38%,#00b0bb 50%,#005391 62%,#42257f 84%,#7a6f54)

.gold:after
  background linear-gradient(130deg, rgba(255,255,255,1) 0%, rgba(175,132,0,1) 30%, rgba(255,255,255,1) 50%, rgba(175,132,0,1) 70%, rgba(255,255,255,1) 100%)

.silver:after
  background linear-gradient(130deg, rgba(255,255,255,1) 0%, rgba(68,68,68,1) 30%, rgba(255,255,255,1) 50%, rgba(68,68,68,1) 70%, rgba(255,255,255,1) 100%)
</style>



// WEBPACK FOOTER //
// src/components/pages/color/Color.vue